import { useContext } from 'react'
import { ModalContext } from 'providers/Modal'

const Panel = props => {
  const { activeForm } = useContext(ModalContext)
  return activeForm === props.isActive ? props.children : null
}

export default Panel
